export default "__VITE_ASSET__7377172b__"